module.exports = __webpack_public_path__ + "static/media/pinIcon.a6f3ddc9.svg";